function resize_promo(){
  if(document.querySelectorAll('.snippet-promo-image.desk-promo')) document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
    setTimeout(() => {
      let prev = promo.previousSibling;
      if(prev){
        if(prev.classList.contains('product-item')){
          promo.style.height = ((prev.clientHeight*2+32) - prev.querySelector('.grid-meta').clientHeight) +'px';
        }
      }
    }, 800);
  })
  document.querySelectorAll('.product-item').forEach((desk_grid) => {
      desk_grid.classList.remove('coll-grid-desk-space');
  });
  let grid = document.querySelector(".collection-grid");
  let products = Array.from(grid.querySelectorAll(".product-item"));
  let productsPerRow = parseInt(grid.getAttribute("data-desk"), 10) || 6;
  let visibleCount = 0;
  products.forEach((product) => {
      if (product.style.display !== "none") {
          visibleCount++;
          let productRect = product.getBoundingClientRect();
          if ((visibleCount - 1) % productsPerRow === 0 || productRect.left === 0) {
              product.classList.add("coll-grid-desk-space");
          }
      }
  });
  document.dispatchEvent(new 
  CustomEvent("swym:collections-loaded"));
  
  let images = document.querySelectorAll(".product-images img:not(.second-image)");
  images.forEach((img) => {
    if(img.complete){
      img.classList.add("loaded");
    }else{
      img.addEventListener("load", () => img.classList.add("loaded"));
    }
  });
  
}
function quick_buy_btn(){
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  resize_promo();
}
// function load_more(){
//   const loadMoreBtn = document.querySelector('.load-more');
//   let currentRowsLoaded = 2;
//   const desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk'));
//   const mobileProductsPerRow = 2;
//   const rowsPerLoad = 2;
//   const desktopProductsPerLoad = rowsPerLoad * desktopProductsPerRow;
//   const mobileProductsPerLoad = rowsPerLoad * mobileProductsPerRow;
//   const desktopPromoImages = document.querySelectorAll('.snippet-promo-image.desk-promo');
//   const mobilePromoImages = document.querySelectorAll('.snippet-promo-image.mb-promo');
//   const isMobile = window.innerWidth < 992;
//   const getProductsPerRow = () => (isMobile ? mobileProductsPerRow : desktopProductsPerRow);
//   if(loadMoreBtn){
//     loadMoreBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       const nextPageUrl = loadMoreBtn.getAttribute('href');
//       if (!nextPageUrl) return;
//       if(document.querySelector('.coll-more-scroll')) document.querySelector('.coll-more-scroll').classList.add('loading');
//       fetch(nextPageUrl)
//         .then(response => response.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');
//           const newProducts = doc.querySelectorAll('.collection-grid .product-item');
//           const nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');
//           const productGrid = document.querySelector('#product-grid');
//           newProducts.forEach(product => productGrid.appendChild(product));
//           const displayPromoImages = (promoImages, rowAttribute) => {
//             promoImages.forEach(promo => {
//               const promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
//               const productsPerRow = getProductsPerRow();
//               const productsLoaded = currentRowsLoaded * productsPerRow;
//               if(promoRow <= currentRowsLoaded + rowsPerLoad && promo.style.display === 'none'){
//                 promo.style.display = 'block';
//                 productGrid.appendChild(promo);
//               }
//             });
//           };
//           if(isMobile){
//             displayPromoImages(mobilePromoImages, 'data-mob-row');
//           }else{
//             displayPromoImages(desktopPromoImages, 'data-desk-row');
//           }
//           currentRowsLoaded += rowsPerLoad;
//           if(nextPaginationLink){
//             loadMoreBtn.setAttribute('href', nextPaginationLink.getAttribute('href'));
//           }else{
//             document.querySelector('.coll-more-scroll').remove();
//           }
//           if(document.querySelector('.coll-more-scroll')) document.querySelector('.coll-more-scroll').classList.remove('loading');
//           quick_buy_btn();
//         })
//         .catch(err => console.error('Error loading products:', err));
//     });
//   }
// }
function load_more(){
  const loadMoreBtn = document.querySelector('.load-more');
  let currentRowsLoaded = 2;
  let isLoading = false;
  const desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk'));
  const mobileProductsPerRow = 2;
  const rowsPerLoad = 2;
  const desktopPromoImages = document.querySelectorAll('.snippet-promo-image.desk-promo');
  const mobilePromoImages = document.querySelectorAll('.snippet-promo-image.mb-promo');
  const isMobile = window.innerWidth < 992;
  const getProductsPerRow = () => (isMobile ? mobileProductsPerRow : desktopProductsPerRow);
  const productGrid = document.querySelector('#product-grid');
  const loadNextPage = () => {
    if (!loadMoreBtn || isLoading) return;
    const nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl) return;
    isLoading = true;
    if (document.querySelector('.coll-more-scroll')) {
      document.querySelector('.coll-more-scroll').classList.add('loading');
    }
    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        document.querySelectorAll('.blank-span').forEach(blankDiv => {
          blankDiv.remove();
        });
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('.collection-grid .product-item');
        const nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');
        newProducts.forEach(product => {
          const productId = product.getAttribute('data-id');
          if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
            productGrid.appendChild(product);
          }
        });
        let parentElement = document.querySelector('.collection-grid');
        for(let i = 0; i < parseInt(document.querySelector('.collection-grid').getAttribute('data-limit')); i++){
          let span = document.createElement("span");
          span.classList.add("blank-span");
          parentElement.appendChild(span);
        }
        const displayPromoImages = (promoImages, rowAttribute) => {
          promoImages.forEach(promo => {
            const promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
            const productsPerRow = getProductsPerRow();
            const productsLoaded = currentRowsLoaded * productsPerRow;
  
            if (promoRow <= currentRowsLoaded + rowsPerLoad && promo.style.display === 'none') {
              promo.style.display = 'block';
              productGrid.appendChild(promo);
            }
          });
        };
        if (isMobile) {
          displayPromoImages(mobilePromoImages, 'data-mob-row');
        } else {
          displayPromoImages(desktopPromoImages, 'data-desk-row');
        }
        currentRowsLoaded += rowsPerLoad;
        if (nextPaginationLink) {
          loadMoreBtn.setAttribute('href', nextPaginationLink.getAttribute('href'));
        } else {
          document.querySelector('.coll-more-scroll').remove();
        }
        if (document.querySelector('.coll-more-scroll')) {
          document.querySelector('.coll-more-scroll').classList.remove('loading');
        }
        quick_buy_btn();
      })
      .catch(err => console.error('Error loading products:', err))
      .finally(() => {
        isLoading = false;
      });
  };
  const observeLoadMoreBtn = () => {
    if (!loadMoreBtn) return;
    const observerOptions = {
      root: null,
      threshold: 0.5,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage();
        }
      });
    }, observerOptions);
    observer.observe(loadMoreBtn);
  };
  observeLoadMoreBtn();
}
document.addEventListener('DOMContentLoaded', () => {
  const productLinks = document.querySelectorAll('.product-item a');
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  productLinks.forEach(link => {
    link.addEventListener('click', () => {
      sessionStorage.setItem(`${collectionHandle}-scrollPos`, window.scrollY);
      sessionStorage.setItem(`${collectionHandle}-gridHTML`, productGrid.innerHTML);
      if(loadMoreBtn) sessionStorage.setItem(`${collectionHandle}-loadMoreHref`, loadMoreBtn.getAttribute('href'));
      sessionStorage.setItem(`${collectionHandle}-rowsLoaded`, currentRowsLoaded);
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedScrollPos = sessionStorage.getItem(`${collectionHandle}-scrollPos`);
  const savedGridHTML = sessionStorage.getItem(`${collectionHandle}-gridHTML`);
  const savedLoadMoreHref = sessionStorage.getItem(`${collectionHandle}-loadMoreHref`);
  const savedRowsLoaded = sessionStorage.getItem(`${collectionHandle}-rowsLoaded`);
  if(savedGridHTML && savedScrollPos){
    productGrid.innerHTML = savedGridHTML;
    if(savedLoadMoreHref && loadMoreBtn) loadMoreBtn.setAttribute('href', savedLoadMoreHref);
    if(savedRowsLoaded) currentRowsLoaded = parseInt(savedRowsLoaded, 10);
    window.scrollTo(0, parseInt(savedScrollPos, 10));
    sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
    sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
    sessionStorage.removeItem(`${collectionHandle}-loadMoreHref`);
    sessionStorage.removeItem(`${collectionHandle}-rowsLoaded`);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector('.coll-desc')){
    const descWrapper = document.querySelector(".coll-desc-wrapper");
    const shortDesc = descWrapper.querySelector(".coll-short-desc");
    const longDesc = descWrapper.querySelector(".coll-long-desc");
    const readMoreBtn = descWrapper.querySelector(".coll-desc-read");
    function checkDescription() {
      const shortDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "unset";
      const fullDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "2";
      if (fullDescHeight <= shortDescHeight) {
        readMoreBtn.style.display = "none";
      } else {
        readMoreBtn.style.display = "inline-block";
      }
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight+'px';
    }
    window.addEventListener("resize", checkDescription);
    checkDescription();
  }
});
document.addEventListener("DOMContentLoaded", (event) => {
  load_more();
  if(document.querySelector('.coll-desc-read')) document.querySelector('.coll-desc-read').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.coll-desc').classList.toggle('active-full-desc');
    if(document.querySelector('.coll-desc.active-full-desc')){
      document.querySelector('.coll-desc.active-full-desc').style.maxHeight = '';
    }
  });
  if(localStorage.getItem("collection_grid") == null){
    localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
  }else{
    document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
    if(document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")){
      document.querySelector(".coll-view a.active").classList.remove('active')
      let deskGrids = document.querySelectorAll(".coll-view a");
      deskGrids.forEach((deskGrid) => {
        let desk_val = deskGrid.getAttribute('data-view')
        if(parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))){
          deskGrid.classList.add('active')
        }
      });
    }
  }
  if(document.querySelectorAll('.coll-view a')) document.querySelectorAll('.coll-view a').forEach((grid) => {
    grid.addEventListener('click',function(e){
      e.preventDefault();
      localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
      document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
      const desk_grids = document.querySelectorAll(".coll-view a.active");
      desk_grids.forEach((desk_grid) => {
        desk_grid.classList.remove("active");
      });
      grid.classList.add("active");
      resize_promo();
    });
  });
  if(document.querySelector('.coll-title')) document.querySelector('.coll-title').addEventListener('click',function(e){
    e.preventDefault();
    if(document.body.classList.contains('sticky-filter')){
      document.body.classList.toggle('open-subcoll');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search','open-filter');
    }
  })
  resize_promo();
});
window.addEventListener("resize", resize_promo);
window.addEventListener('scroll', (e)=> {
  if(document.querySelector('.coll-desc')){
    let scrollDistance = window.pageYOffset
    if(scrollDistance > 0){
      document.querySelector('.coll-desc').style.maxHeight = '0px'
      document.querySelector('.coll-desc').classList.add('scroll-start')
    }else{
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight+'px'
      document.querySelector('.coll-desc').classList.remove('scroll-start')
    }
  }
})


// infinitescroll remember scroll position

function attachClickEvent() {
  document.querySelectorAll('.load-more a').forEach(anchor => {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  });

  // Save scroll position and loaded products before navigating to the product page
  document.querySelectorAll('#product-grid a').forEach(anchor => {
    anchor.addEventListener('click', function() {
      sessionStorage.setItem('scrollPosition', window.scrollY);
      saveLoadedProducts();
    });
  });
}

// Save the HTML content of the loaded products
function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#product-grid").innerHTML;
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);
}

// Restore scroll position and loaded products when the page is loaded
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/collections')) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#product-grid").innerHTML = loadedProducts;
      sessionStorage.removeItem('loadedProducts');
    }
    if (scrollPosition && collectionURL === window.location.href) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    attachClickEvent();
  }
});

// Save state when clicking on a product link
document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

// Save scroll position before the user leaves the page
window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});


// Clear only collection-related sessionStorage keys when navigating to a new collection
document.querySelectorAll('.menu-drawer-wrapper a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    // Loop through sessionStorage keys and remove only collection-related ones
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('collection') || key.includes('scrollPosition') || key.includes('gridHTML') || key.includes('loadMoreHref') || key.includes('rowsLoaded')) {
        sessionStorage.removeItem(key);
      }
    });
  });
});

// Restore scroll position when the page is shown (including back navigation)
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
  }
});